export const addLike = resp => {
  return {
    type: "ADD_LIKE",
    payload: resp
  };
};
export const addDisLike = resp => {
  return {
    type: "ADD_DISLIKE",
    payload: resp
  };
};
export const addToFav = resp => {
  return {
    type: "ADD_TO_FAV",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/social.js